const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const EmptyRouterView = () => import(/* webpackChunkName: "exoty" */ '@/components/EmptyRouter.vue');
const TransactionTextEdit = () => import(/* webpackChunkName: "transaction" */ './text/view/edit.vue');
const TransactionTextExport = () => import(/* webpackChunkName: "transaction" */ './text/view/export.vue');
const TransactionTextList = () => import(/* webpackChunkName: "transaction" */ './text/view/index.vue');

export const ROUTE_NAME_TRANSACTION = {
    TEXT: {
        EXPORT: 'TransactionTextExport',
        INDEX: 'TransactionTextList',
        EDIT: 'TransactionTextEdit'
    }
} as const;

export default [
    {
        path: '/app/:appId/transaction/text',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: 'export',
                name: ROUTE_NAME_TRANSACTION.TEXT.EXPORT,
                component: TransactionTextExport,
                meta: { requiresAuth: true }
            },
            {
                path: 'item',
                component: EmptyRouterView,
                meta: { requiresAuth: true },
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_TRANSACTION.TEXT.INDEX,
                        component: TransactionTextList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':code/:locale',
                        name: ROUTE_NAME_TRANSACTION.TEXT.EDIT,
                        component: TransactionTextEdit,
                        meta: { requiresAuth: true }
                    }
                ]
            }
        ]
    }
];
